import React, {useEffect, useState} from 'react';
import {Student} from "features/model/types/lessonsStudents";
import {toggleAttendance} from "features/model/service/groups/groups-lessons/toggle-attendance/fetchToggleAttendance";
import {useAppDispatch, useAppSelector} from "common/hook";
import {NavLink, useParams} from "react-router-dom";
import {ROLE_HR} from "entities/constants/constants";




export const StudentsItems: React.FC<{ student: Student, groupId: number | null }> = ({student, groupId}) => {
    const dispatch = useAppDispatch();
    const roleType = useAppSelector((state) => state.role.roleType);
    const [isChecked, setIsChecked] = useState(student.attendance);
    const {lessonsId} = useParams();

    const getHomeworkStatusComponent = (status:string) => {
        switch (status) {
            case 'done':
                return (
                    <p className="status-item">
                        <NavLink to={`/lessons/${lessonsId}/home-work/${student.id}`}>Выполнено</NavLink>
                    </p>
                );
            case 'notDone':
                return <p className="status-item not-done">Не выполнено</p>;
            case 'homeworkNotAssigned':
                return <p className="status-item no-homework">Не задавали</p>;
            case 'notVerified':
                return (
                    <p className="status-item no-homework">
                        <NavLink to={`/lessons/${lessonsId}/home-work/${student.id}`}>Не проверено</NavLink>
                    </p>
                );
            case 'partiallyDone':
                return (
                    <p className="status-item partially-done">
                        <NavLink to={`/lessons/${lessonsId}/home-work/${student.id}`}>Частично выполнено</NavLink>
                    </p>
                );
            case 'notAssigned':
                return <p className="status-item not-assigned">Не сдано</p>;
            default:
                return null;
        }
    };


    const handleCheckboxChange = () => {
        setIsChecked(prevState => !prevState);
        dispatch(toggleAttendance({user_id: student.id, value: !isChecked, lessonsId: lessonsId}));
        setIsChecked(!isChecked);
    };

    useEffect(() => {
        setIsChecked(student.attendance);
    }, [student.attendance]);


    return (
        <div className="row">
            <div className="col student-col full-width-mobile">
                <span className="col-title">Студент</span>
                <div className="student-data-box">
                    <div className="avatar">
                        <img src={student.avatar} alt="avatar"/>
                        <span className={`status-label ${student.onlineStatus}`}/>
                    </div>
                    <div className="student-data">
                        <p className="name">
                            <NavLink
                                to={`/groups/${groupId}/students-pages/${student.id}`}>{student.fullName}
                            </NavLink>
                        </p>
                        <div className="data-statistic">
                            {student.cuts !== null && (
                                <div className="data-statisitc-item">
                                    <span className="data-statistic-text">Срезы {" "}</span>
                                    <span className={`data-statistic-val completed-count ${
                                        student.cuts > 50 ? '' : 'low'
                                    }`}
                                    >
                                         {student.cuts}%
                                    </span>
                                </div>
                            )}
                            {student.efficiency !== null && (
                            <div className="data-statisitc-item">
                                <span className="data-statistic-text">Эффективность {" "}</span>
                                <span
                                    className={`data-statistic-val completed-count ${
                                        student.efficiency > 50 ? '' : 'low'
                                    }`}
                                >
                                 {student.efficiency}%
                                </span>
                            </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="col presence-col">
                <span className="col-title">Присутствие</span>
                <div className="switch-box">
                    <div className="switch-btn">
                        <input
                            id={`lst-switch-btn-${student.id}`}
                            type="checkbox"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                            disabled={roleType === ROLE_HR}
                        />
                        <label htmlFor={`lst-switch-btn-${student.id}`} className="tooltip"/>
                    </div>
                </div>

            </div>
            <div className="col homework-col">
                <span className="col-title">Домашнее задание</span>
                {getHomeworkStatusComponent(student.homeworkStatus)}
            </div>

            <div className="col test-amount-col align-right">
                <span className="col-title">Тест</span>
                <p>{student.test}/{student.testAll}</p>
            </div>
        </div>
    );
};
